import React from "react";
import Slider from "react-slick";
import { Link, useParams } from "react-router-dom";
import ProductCard from "../../shared/ProductCard";
import { useTranslation } from "react-i18next";
import "./RelatedProductsSlider.css";

const RelatedProductsSlider = ({ relatedProducts }) => {
  const { id } = useParams();
  const { t, i18n } = useTranslation(); // Thêm useTranslation

  // Ánh xạ maloaisp sang id
  const getCategoryId = (maloaisp) => {
    switch (maloaisp) {
      case 1:
        return "henk";
      case 2:
        return "mark-and-milk";
      case 7:
        return "mekong-cocoa";
      case 8:
        return "ganafarm";
      default:
        return id; // Fallback về id hiện tại
    }
  };

  const settings = {
    infinite: true,
    swipeToSlide: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, slidesToScroll: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 2, slidesToScroll: 2 },
      },
    ],
  };

  if (!relatedProducts || relatedProducts.length === 0) return null;

  return (
    <div className="related-slider-container container">
      <h4 className="mb-4">
        <strong>{t("detail_related")}:</strong>
      </h4>
      <Slider {...settings}>
        {relatedProducts.map((product, index) => {
          const productCategoryId = getCategoryId(product.maloaisp);

          return (
            <div key={index} className="related-slide-item">
              <ProductCard
                product={product}
                link={`/san-pham/${productCategoryId}/${product.slug}`}
                stateData={{ product }}
              />
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default RelatedProductsSlider;
